import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScroll } from 'react-use';
import { styled } from 'styled-components';
import SvgChevron from '../../../../../play-core/icons/Chevron';
import { Colors } from '../../../../../play-core/styles/Colors';
import { zIndex } from '../../../../../play-core/styles/z-index';
import { Button } from '../../ClickableComponents/Button';
import { colorSets } from '../../ClickableComponents/styles';
import { ShadowOverlay } from '../ShadowOverlay';
import { TimeJumpButtons } from '../TimeJumpButtons';
import { calculateStickyPosition } from '../tv-guide-helper';
import { gridChannelWidth, gridGap, gridScrollbarHeight, gridTimelineHeight, scrollFactor, scrollRightBy } from '../tv-guide-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GridScrollButtons = ({
  scrollRef,
  date,
  pixelsPerMinute,
  stickyTopPosition
}) => {
  const {
    t
  } = useTranslation();
  const {
    x
  } = useScroll(scrollRef);
  const [scrollPosition, setScrollPosition] = useState(0);
  const totalScroll = scrollRef.current ? scrollRef.current.scrollWidth - scrollRef.current.clientWidth : 0;
  const showShadowLeft = scrollPosition > 5;
  const showShadowRight = scrollRef.current ? scrollPosition < totalScroll - 5 : false;

  // useScroll does not detect changes of the scroll x position, when we scroll
  // to a new position in useScrollToInitialPosition. We therefore have to manually
  // read the current scroll position, whenever 'date' changes.
  useEffect(() => {
    setScrollPosition(x);
    setTimeout(() => {
      const scrollX = scrollRef.current?.scrollLeft ?? x;
      setScrollPosition(scrollX);
    }, 0);
  }, [date, x, scrollRef]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(Layout, {
      stickyTopPosition: stickyTopPosition,
      children: [/*#__PURE__*/_jsx(Button, {
        type: "icon",
        ariaLabel: t('global.scrollLeft'),
        icon: /*#__PURE__*/_jsx(SvgChevron, {
          orientation: "left"
        }),
        colorSet: {
          iconColor: colorSets.transparent.iconColor,
          backgroundColor: Colors.GREY_1a1a1a
        },
        onClick: () => {
          if (scrollRef.current) {
            const scrollAmount = Math.round(scrollRef.current.clientWidth * scrollFactor);
            scrollRightBy(scrollRef, -scrollAmount);
          }
        },
        isDisabled: scrollPosition === 0,
        tabIndex: -1
      }), /*#__PURE__*/_jsx(Button, {
        type: "icon",
        ariaLabel: t('global.scrollRight'),
        icon: /*#__PURE__*/_jsx(SvgChevron, {
          orientation: "right"
        }),
        colorSet: {
          iconColor: colorSets.transparent.iconColor,
          backgroundColor: Colors.GREY_1a1a1a
        },
        onClick: () => {
          if (scrollRef.current) {
            const scrollAmount = Math.round(scrollRef.current.clientWidth * scrollFactor);
            scrollRightBy(scrollRef, scrollAmount);
          }
        },
        isDisabled: scrollPosition >= totalScroll,
        tabIndex: -1
      }), /*#__PURE__*/_jsx(TimeJumpButtons, {
        scrollPosition: scrollPosition,
        scrollRef: scrollRef,
        date: date,
        pixelsPerMinute: pixelsPerMinute,
        left: gridChannelWidth,
        top: gridTimelineHeight + gridGap
      })]
    }), /*#__PURE__*/_jsx(ShadowOverlay, {
      position: "Left",
      style: {
        left: `${gridChannelWidth}px`,
        top: `${gridTimelineHeight + gridGap}px`,
        bottom: `${gridScrollbarHeight}px`
      },
      visible: showShadowLeft
    }), /*#__PURE__*/_jsx(ShadowOverlay, {
      position: "Right",
      style: {
        top: `${gridTimelineHeight + gridGap}px`,
        bottom: `${gridScrollbarHeight}px`
      },
      visible: showShadowRight
    })]
  });
};
const Layout = styled.div.withConfig({
  displayName: "GridScrollButtons__Layout",
  componentId: "sc-wyfa1t-0"
})(["z-index:", ";pointer-events:all;height:0;width:100%;display:flex;justify-content:space-between;", ""], zIndex.floatingAction, ({
  stickyTopPosition
}) => calculateStickyPosition(stickyTopPosition));